export default __webpack_public_path__ + "assets/images/2332f635330b218353c7eb3c8844a07b.svg";